import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

function isTokenExpired(token: string): boolean {
  try {
    const payloadPart = token.split('.')[1];
    if (!payloadPart) return true;
    const payload = JSON.parse(atob(payloadPart.replace(/-/g, '+').replace(/_/g, '/')));
    const exp = payload?.exp as number | undefined; // seconds since epoch
    if (!exp) return true;
    const now = Math.floor(Date.now() / 1000);
    return exp <= now;
  } catch {
    return true;
  }
}

export const authGuard: CanActivateFn = (route, state): boolean | UrlTree => {
  const router = inject(Router);

  let token: string | null = null;
  if (typeof window !== 'undefined') {
    token = localStorage.getItem('tokenn');
  }

  const invalid = !token || isTokenExpired(token);
  if (invalid) {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('tokenn');
      localStorage.removeItem('userInfo');
    }
    // Only pass relative paths as returnUrl to prevent open redirect
    const url = state.url;
    const safeReturnUrl = url.startsWith('/') && !url.startsWith('//') ? url : '/dashboard';
    return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: safeReturnUrl } });
  }

  return true;
};
